import React from 'react';

import { Skeleton } from 'primereact/skeleton';
import { LiliTransaction } from '../../types/lili-transaction';
import { transactionETA, transactionStatusOnTransactionsTable } from '../../utils/transaction-status';

export const transactionStatus = (t: LiliTransaction, isLoadingTable?: boolean) => {
  const status = transactionStatusOnTransactionsTable(t);
  const eta = transactionETA(t);

  if (isLoadingTable) {
    return (
      <div className='flex align-items-center' style={{ height: '17px', flexGrow: '1', overflow: 'hidden' }}>
        <Skeleton width='100%' height='1rem' />
      </div>
    );
  }

  return (
    <div className='font-metricR text-sm'>
      <p id='status' className='text-bw08'>{status}</p>
      <p id='eta' className='text-bw07'>{eta}</p>
    </div>
  );
};
